// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"UserInfo__materialize-textarea___19zz1","modal-2463794813":"UserInfo__modal-2463794813___1oaTz","container":"UserInfo__container___3cPL0","studentContainer":"UserInfo__studentContainer___38Vhd","header":"UserInfo__header___3qdvG","imageContainer":"UserInfo__imageContainer___K_KkI","textContainer":"UserInfo__textContainer___1bjKX","userIcon":"UserInfo__userIcon___2voHS","removePadding":"UserInfo__removePadding___32BEK","deleteButtonContainer":"UserInfo__deleteButtonContainer___3adAO"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Admin/components/Userinfo/UserInfo.scss
// module id = 1567
// module chunks = 0